module.exports = __webpack_public_path__ + "static/assets/94b02bb03ed16e390321b636a65ec742.png";